// assets
import {
  IconTypography,
  IconPalette,
  IconShadow,
  IconWindmill,
  IconUniverse,
  IconHandClick,
  IconRobot,
  IconTools,
  IconAdjustmentsSearch,
  IconSettings2,
  IconDeviceAudioTape,
  IconDeviceDesktopUp,
  IconTableFilled
} from '@tabler/icons-react';

// constant
const icons = {
  IconUniverse,
  IconTypography,
  IconPalette,
  IconShadow,
  IconWindmill,
  IconTableFilled,
  IconHandClick,
  IconRobot,
  IconTools,
  IconAdjustmentsSearch,
  IconSettings2,
  IconDeviceAudioTape,
  IconDeviceDesktopUp
};

// ==============================|| PROMPTS MENU ITEMS ||==============================
// Each prompt exists as two fully independent library entries — ForeCite and
// WatchFull — so editing one product's copy never touches the other's.
// See the "Split the Prompt Library" migration for background.

// [id, title, icon, foreciteId, watchfullId]
const SPLIT_PROMPTS = [
  ['universal', 'Universal', icons.IconUniverse, '6a6fc5c73c1711945163d196', '6a6fc5c73c1711945163d197'],
  ['query_builder', 'Search Terms', icons.IconTools, '6a6fc5c83c1711945163d198', '6a6fc5c83c1711945163d199'],
  ['analyze_content', 'Headline & TL;DR', icons.IconAdjustmentsSearch, '6a6fc5c93c1711945163d19a', '6a6fc5c93c1711945163d19b'],
  ['apply_preferences', 'Deep Dive Personalization', icons.IconSettings2, '6a6fc5c93c1711945163d19c', '6a6fc5ca3c1711945163d19d'],
  ['key_insights', 'Consensus Builder', icons.IconDeviceAudioTape, '6a6fc5ca3c1711945163d19e', '6a6fc5ca3c1711945163d19f'],
  ['newsletterAudio', 'Podcast Script', icons.IconDeviceAudioTape, '6a6fc5cb3c1711945163d1a0', '6a6fc5cb3c1711945163d1a1'],
  ['socialShare', 'Social Share', icons.IconPalette, '6a6fc5cd3c1711945163d1a4', '6a6fc5cd3c1711945163d1a5'],
  ['inquiry', 'Insight 1', icons.IconTableFilled, '6a6fc5ce3c1711945163d1a6', '6a6fc5ce3c1711945163d1a7'],
  ['monitor_bot', 'Insight 2', icons.IconRobot, '6a6fc5cf3c1711945163d1a8', '6a6fc5cf3c1711945163d1a9'],
  ['follow_up', 'Follow Up', icons.IconDeviceDesktopUp, '6a6fc5d03c1711945163d1aa', '6a6fc5d03c1711945163d1ab'],
  ['hotTake', 'Hot Take', icons.IconWindmill, '6a6fc5d03c1711945163d1ac', '6a6fc5d13c1711945163d1ad'],
  ['channelAnswerNarrative', 'Channel Answer Narrative', icons.IconDeviceAudioTape, '6a6fc5d13c1711945163d1ae', '6a6fc5d13c1711945163d1af'],
  ['perspectives', 'Perspectives', icons.IconTypography, '6a6fc5d23c1711945163d1b0', '6a6fc5d23c1711945163d1b1']
];

// Counter Argument is intentionally cross-named: each product's copy is a
// teaser promoting the *other* product, so the id/title pairing is swapped.
const COUNTER_ARGUMENT_FORECITE_ID = '6a6fc5cc3c1711945163d1a2'; // "ForeCite — WatchFull Teaser"
const COUNTER_ARGUMENT_WATCHFULL_ID = '6a6fc5cc3c1711945163d1a3'; // "WatchFull — ForeCite Teaser"

function buildGroup(id, title, productKey) {
  const children = SPLIT_PROMPTS.map(([itemId, itemTitle, icon, foreciteId, watchfullId]) => ({
    id: `${productKey}_${itemId}`,
    title: itemTitle,
    type: 'item',
    url: `/prompts/${productKey === 'forecite' ? foreciteId : watchfullId}`,
    icon,
    breadcrumbs: false
  }));

  children.push({
    id: `${productKey}_counterArgument`,
    title: productKey === 'forecite' ? 'WatchFull Teaser' : 'ForeCite Teaser',
    type: 'item',
    url: `/prompts/${productKey === 'forecite' ? COUNTER_ARGUMENT_FORECITE_ID : COUNTER_ARGUMENT_WATCHFULL_ID}`,
    icon: icons.IconShadow,
    breadcrumbs: false
  });

  return { id, title, type: 'group', children };
}

const forecitePrompts = buildGroup('forecite-prompts', 'ForeCite Prompts', 'forecite');
const watchfullPrompts = buildGroup('watchfull-prompts', 'WatchFull Prompts', 'watchfull');

const sharedPrompts = {
  id: 'shared-prompts',
  title: 'Shared Prompts',
  type: 'group',
  children: [
    {
      id: 'greeting',
      title: 'Welcome/Greeting',
      type: 'item',
      url: '/prompts/6624116447a0306e23402764',
      icon: icons.IconHandClick,
      breadcrumbs: false
    }
  ]
};

export { forecitePrompts, watchfullPrompts, sharedPrompts };
export default forecitePrompts;
